import {getCookieValue} from "./utilityFunctions";
import {ANALYTICS_COOKIES} from "./constants";

export default () => {
    'use strict';

    const appendSessionParamsToURL = (link: string): string => {
        const cookieValue = getCookieValue(ANALYTICS_COOKIES);
        let linkUrl: URL;
        try {
            linkUrl = new URL(link);
        } catch {
            return link;
        }

        const isGrailHost =
            linkUrl.hostname === 'grail.com' || linkUrl.hostname.endsWith('.grail.com');

        if (!cookieValue || linkUrl.protocol !== 'https:' || !isGrailHost) {
            return link;
        }

        let sessionData: Record<string, unknown>;
        try {
            sessionData = JSON.parse(decodeURIComponent(cookieValue));
        } catch {
            return link;
        }

        for (const [key, value] of Object.entries(sessionData)) {
            if (value != null && typeof value !== 'object') {
                linkUrl.searchParams.set(key, String(value));
            }
        }

        return linkUrl.toString();
    }

    const isGrailPortalLink = (link: string): boolean => {
        try {
            const url = new URL(link);
            return (
                url.protocol === "https:" &&
                /^([a-zA-Z0-9-]+\.)?grail\.com$/.test(url.hostname)
            );
        } catch {
            return false;
        }
    }

    const links = document.querySelectorAll('a');
    const grailPortalLinks: HTMLAnchorElement[] = [];

    for (const link of links) {
        // Store grail portal links for later redirect processing
        const href = link.getAttribute('href') ?? '';
        if (isGrailPortalLink(href)) {
            grailPortalLinks.push(link as HTMLAnchorElement);
        }

        if (href) {
            // Append links to grail.com or grail.com subdomains with session params
            link.href = appendSessionParamsToURL(href);

            // Allow links with href to open modals
            // example: /modals/my-custom-modal"
            if (href.includes('/modals/')) {
                const modalSlug = href.split('/modals/')[1]
                const modal = document.querySelector(`[data-modal-slug = "${modalSlug}"]`)
                link.addEventListener('click', e => {
                    e.preventDefault();
                    if (modal) {
                        window.bootstrap.Modal.getOrCreateInstance(modal).show();
                    }
                })
            }
        }
    }

    // Load globals data asynchronously and apply redirect when ready
    fetch('/actions/grail-galleri-globals/globals-data')
        .then(response => response.json())
        .then(globalsData => {
            if (globalsData && 'grailPortal' in globalsData) {
                const activateRedirection = globalsData.grailPortal.activateRedirection;
                const internalPage = globalsData.grailPortal.internalPage;
                
                if (activateRedirection && internalPage) {
                    // Apply redirect to grail portal links
                    grailPortalLinks.forEach(link => {
                        link.href = internalPage;
                    });
                }
            }
        })
        .catch(error => {
            console.error('Failed to load globals data:', error);
        });

    // Append forms POST to grail.com or grail.com subdomains with session params
    const grailForms = document.querySelectorAll('[action*="grail.com"]');
    grailForms.forEach(form => {
        const formAction = form.getAttribute('action') ?? '';
        if (formAction) form.setAttribute('action', appendSessionParamsToURL(formAction));
    })

}
